import { NgModule } from '@angular/core';

import { MichelinStockRoutingModule } from './michelin-stock.routing';
import { ListMichelinStockComponent } from './list-michelin-stock/list-michelin-stock.component';
import { UpdateMichelinStockComponent } from './update-michelin-stock/update-michelin-stock.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ListMichelinStockComponent, UpdateMichelinStockComponent],
  imports: [SharedModule, MichelinStockRoutingModule]
})
export class MichelinStockModule {}
